<script>
import options from './ArticleOverlay.options'
export default options
</script>

<template>
  <article class="kb-article-overlay">
    <div v-html="html"></div>
  </article>
</template>
